var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDialogClose = function SvgDialogClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 12 12",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11 1-10 10m0-10 10 10",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};

export { SvgDialogClose as ReactComponent };
export default __webpack_public_path__ + "4291709405af91b0ca5981f57b2fa37b.svg";